import React from "react";
import { IconName } from "../../icon";
import ImageWithIcon from "../../common/image-with-icon";
var ContentImage = function ContentImage(_ref) {
    var index = _ref.index, image = _ref.image, selectImage = _ref.selectImage, showModal = _ref.showModal;
    var onClick = function onClick() {
        selectImage(image.image);
        showModal();
    };
    return /*#__PURE__*/ React.createElement("div", {
        key: index,
        className: "article-content-image my-4"
    }, /*#__PURE__*/ React.createElement(ImageWithIcon, {
        image: image.image,
        onClick: onClick,
        icon: IconName.EXPAND
    }), image.description && /*#__PURE__*/ React.createElement("div", {
        className: "mt-2 text-sm break-words"
    }, image.description));
};
export default ContentImage;
